export default {
  '400': {
    title: 'Requisição inválida',
    description: 'Parece que o link em que você clicou tem um pequeno problema, por isso não conseguimos processar sua solicitação.',
  },
  '404': {
    title: 'Não encontrado',
    description: 'A página que você procura pode ter sido removida, ter mudado de nome ou estar temporariamente indisponível.',
  },
  '500': {
    title: 'Erro interno do servidor',
    description: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
  },
  'call-dispatcher': 'Ligar para a central',
  'error-code': 'Erro {code}',
  'dispatcher-hint': 'Entre em contato com a central da Rx2Go <br /> se você vir este erro',
  generic: {
    title: 'Algo deu errado',
    description: 'Algo deu errado',
  },
  'server-error': 'Erro do servidor',
  'cant-request': 'Não foi possível fazer a solicitação',
  'no-order-id': 'Sem número do pedido',
}
